import React from "react";
import { Checkbox } from "antd";

/* The one field that keeps its own label: a checkbox reads as "[x] Active", not as a label above
   an empty box. `ResourceForm` renders its `<Form.Item>` without one. */
export default function CheckboxField({ field, value, onChange }) {
  return (
    <Checkbox checked={!!value} onChange={event => onChange(field.name, event.target.checked)}>
      {field._label}
    </Checkbox>
  );
}
